export default __webpack_public_path__ + "static/media/sticker-R.66199791.png";